import { render, staticRenderFns } from "./EditCustomerRemarkDialog.vue?vue&type=template&id=25c5b9a6&scoped=true"
import script from "./EditCustomerRemarkDialog.vue?vue&type=script&lang=js"
export * from "./EditCustomerRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./EditCustomerRemarkDialog.vue?vue&type=style&index=0&id=25c5b9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5b9a6",
  null
  
)

export default component.exports